import React, { useEffect, useState } from "react";

// import WallDataService from "../services/wall.services";
import { storage, firestore, auth } from "../firebase";
import firebase from "firebase/compat/app";
import { snapshotEqual, update } from "firebase/firestore";
import { useParams, Link } from "react-router-dom";
import { useUserProvider } from "../context/UserProvider";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify"; // then this

import {
  collection,
  getDocs,
  getDoc,
  addDoc,
  updateDoc,
  deleteDoc,
  doc,
} from "firebase/firestore";

import {
  Card,
  CardContent,
  Button,
  TextField,
  Stack,
  FormControl,
  FormGroup,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  Select,
  InputLabel,
  MenuItem,
  Grid,
  Typography,
  OutlinedInput,
  InputAdornment,
  Switch,
} from "@mui/material";
import { ContentPasteGo } from "@mui/icons-material";

export default function EditMeasurement(props) {
  const history = useHistory();
  const { user } = useUserProvider();
  const { uid, displayName, email, photoURL } = auth.currentUser || {};
  const { id } = useParams();

  const measurementId = props.id;

  const wallRef = firestore.doc(
    `sites/${props.siteId}/walls/${props.wallId}/measurements/${measurementId}`
  );

  const [formData, setFormData] = useState({
    directionOfEmission: "",
    typeOfNoise: "",
    spectrumOfMeasurements: "",
    DnTw_100_3150Hz: "",
    C_100_3150Hz: "",
    CTR_100_3150Hz: "",
    // cs_50Hz: "",
    // cs_63Hz: "",
    // cs_80Hz: "",
    cs_100Hz: "",
    cs_125Hz: "",
    cs_160Hz: "",
    cs_200Hz: "",
    cs_250Hz: "",
    cs_315Hz: "",
    cs_400Hz: "",
    cs_500Hz: "",
    cs_630Hz: "",
    cs_800Hz: "",
    cs_1000Hz: "",
    cs_1250Hz: "",
    cs_1600Hz: "",
    cs_2000Hz: "",
    cs_2500Hz: "",
    cs_3150Hz: "",
    // cs_4000Hz: "",
    // cs_5000Hz: "",
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (2 < 1) {
      toast.error("Please complete the required fields", {
        theme: "colored",
      });
      return;
    }
    wallRef.update({
      formData: formData,
    });
    history.push(`/sites/${props.siteId}`);
    toast.success("Measure updated successfully", {
      theme: "colored",
    });
    setFormData("");
  };

  const editHandler = async () => {
    // setMessage("");
    function getMeasurement(measurementId) {
      const measurementDoc = doc(
        firestore,
        "sites",
        props.siteId,
        "walls",
        props.wallId,
        "measurements",
        measurementId
      );
      return getDoc(measurementDoc);
    }
    try {
      const docSnap = await getMeasurement(measurementId);
      // console.log("the record is :", docSnap.data());
      setFormData(docSnap.data().formData);
    } catch (err) {
      // setMessage({ error: true, msg: err.message });
      toast.error("Please complete the required fields", {
        theme: "colored",
      });
    }
  };

  useEffect(() => {
    // console.log("The id here is : ", id);
    // if (id !== undefined && id !== "") {
    editHandler();
    // }
  }, [id]);

  return (
    <>
      {/* <p>{props.siteId}</p>
      <p>{props.wallId}</p>
      <p>{props.id}</p> */}
      <form onSubmit={handleSubmit}>
        <Card sx={{ marginBottom: "30px" }}>
          <CardContent>
            <Grid container spacing={4}>
              <Grid item xs={12}>
                <Typography variant="h5">Direction of emission</Typography>
              </Grid>
              <Grid item xs={12} md={6}>
                <Stack spacing={2}>
                  <FormControl>
                    {/* <FormLabel id="demo-radio-buttons-group-label">
                    Registration period
                  </FormLabel> */}

                    <RadioGroup
                      aria-labelledby="demo-radio-buttons-group-label"
                      name="registration period"
                      value={formData.directionOfEmission}
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          directionOfEmission: e.target.value,
                        })
                      }
                    >
                      <FormControlLabel
                        disabled
                        value={
                          props.stackedRoom1Name
                            ? `${props.stackedRoom1Name} > ${props.stackedRoom2Name}`
                            : `${props.sideRoom1Name} > ${props.sideRoom2Name}`
                        }
                        control={<Radio />}
                        label={
                          props.stackedRoom1Name
                            ? `${props.stackedRoom1Name} > ${props.stackedRoom2Name}`
                            : `${props.sideRoom1Name} > ${props.sideRoom2Name}`
                        }
                      />
                      <FormControlLabel
                        disabled
                        value={
                          props.stackedRoom1Name
                            ? `${props.stackedRoom2Name} > ${props.stackedRoom1Name}`
                            : `${props.sideRoom2Name} > ${props.sideRoom1Name}`
                        }
                        control={<Radio />}
                        label={
                          props.stackedRoom1Name
                            ? `${props.stackedRoom2Name} > ${props.stackedRoom1Name}`
                            : `${props.sideRoom2Name} > ${props.sideRoom1Name}`
                        }
                      />
                    </RadioGroup>
                  </FormControl>
                </Stack>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
        <Card sx={{ marginBottom: "30px" }}>
          <CardContent>
            <Grid container spacing={4}>
              <Grid item xs={12}>
                <Typography variant="h5">Type of noise</Typography>
              </Grid>
              <Grid item xs={12} md={6}>
                <Stack spacing={2}>
                  <FormControl>
                    {/* <FormLabel id="demo-radio-buttons-group-label">
                    Rooms disposal (Before works)
                  </FormLabel> */}
                    <RadioGroup
                      aria-labelledby="demo-radio-buttons-group-label"
                      //   defaultValue="Before Works"
                      name="radio-buttons-group"
                      value={formData.typeOfNoise}
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          typeOfNoise: e.target.value,
                        })
                      }
                    >
                      <FormControlLabel
                        disabled
                        value="Impact noises"
                        control={<Radio />}
                        label="Impact noises"
                      />
                      <FormControlLabel
                        disabled
                        value="Aerial noises"
                        control={<Radio />}
                        label="Aerial Noises"
                      />
                    </RadioGroup>
                  </FormControl>
                </Stack>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
        <Card sx={{ marginBottom: "30px" }}>
          <CardContent>
            <Grid container spacing={4}>
              <Grid item xs={12}>
                <Typography variant="h5">Spectrum of measurements</Typography>
              </Grid>
              <Grid item xs={12} md={6}>
                <Stack spacing={2}>
                  <FormControl>
                    {/* <FormLabel id="demo-radio-buttons-group-label">
                    Rooms disposal (Before works)
                  </FormLabel> */}
                    <RadioGroup
                      aria-labelledby="demo-radio-buttons-group-label"
                      //   defaultValue="Before Works"
                      name="radio-buttons-group"
                      value={formData.spectrumOfMeasurements}
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          spectrumOfMeasurements: e.target.value,
                        })
                      }
                    >
                      <FormControlLabel
                        disabled
                        value="100 Hz - 3150 Hz"
                        control={<Radio />}
                        label="100 Hz - 3150 Hz"
                      />
                      {/* <FormControlLabel
                          value="100 Hz - 3150 Hz"
                          control={<Radio />}
                          label="100 Hz - 3150 Hz"
                        /> */}
                    </RadioGroup>
                  </FormControl>
                </Stack>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
        <Card sx={{ marginBottom: "30px" }}>
          <CardContent>
            <Grid container spacing={4}>
              <Grid item xs={12}>
                <Typography variant="h5">100 Hz - 3150 Hz</Typography>
              </Grid>
              <Grid item xs={12} md={6}>
                <Stack spacing={2}>
                  <FormControl sx={{}} variant="outlined">
                    <TextField
                      type="number"
                      label="DnTw 100 3150Hz"
                      name="DnTw_100_3150Hz"
                      id="DnTw_100_3150Hz"
                      value={formData.DnTw_100_3150Hz}
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          DnTw_100_3150Hz: e.target.value,
                        })
                      }
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">dB</InputAdornment>
                        ),
                      }}
                      aria-describedby="DnTw_100_3150Hz"
                      inputProps={{
                        "aria-label": "DnTw_100_3150Hz",
                      }}
                    />
                  </FormControl>
                  <FormControl sx={{}} variant="outlined">
                    <TextField
                      type="number"
                      label="C 100 3150Hz"
                      name="C_100_3150Hz"
                      id="C_100_3150Hz"
                      value={formData.C_100_3150Hz}
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          C_100_3150Hz: e.target.value,
                        })
                      }
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">dB</InputAdornment>
                        ),
                      }}
                      aria-describedby="C_100_3150Hz"
                      inputProps={{
                        "aria-label": "C_100_3150Hz",
                      }}
                    />
                  </FormControl>
                  <FormControl>
                    <TextField
                      type="number"
                      label="CTR 100 3150Hz"
                      name="CTR_100_3150Hz"
                      id="CTR_100_3150Hz"
                      value={formData.CTR_100_3150Hz}
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          CTR_100_3150Hz: e.target.value,
                        })
                      }
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">dB</InputAdornment>
                        ),
                      }}
                      aria-describedby="CTR_100_3150Hz"
                      inputProps={{
                        "aria-label": "CTR_100_3150Hz",
                      }}
                    />
                  </FormControl>
                </Stack>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
        <Card sx={{ marginBottom: "30px" }}>
          <CardContent>
            <Grid container spacing={4}>
              <Grid item xs={12}>
                <Typography variant="h5">Complete Spectrum</Typography>
              </Grid>
              <Grid item xs={12} md={6}>
                <Stack spacing={2}>
                  {/* <FormControl sx={{}} variant="outlined">
                    <TextField
                      type="number"
                      label="50Hz"
                      name="cs_50Hz"
                      id="cs_50Hz"
                      value={formData.cs_50Hz}
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          cs_50Hz: e.target.value,
                        })
                      }
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">dB</InputAdornment>
                        ),
                      }}
                      aria-describedby="cs_50Hz"
                      inputProps={{
                        "aria-label": "cs_50Hz",
                      }}
                    />
                  </FormControl>
                  <FormControl>
                    <TextField
                      type="number"
                      label="63Hz"
                      name="cs_63Hz"
                      id="cs_63Hz"
                      value={formData.cs_63Hz}
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          cs_63Hz: e.target.value,
                        })
                      }
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">dB</InputAdornment>
                        ),
                      }}
                      aria-describedby="cs_63Hz"
                      inputProps={{
                        "aria-label": "cs_63Hz",
                      }}
                    />
                  </FormControl>
                  <FormControl>
                    <TextField
                      type="number"
                      label="80Hz"
                      name="cs_80Hz"
                      id="cs_80Hz"
                      value={formData.cs_80Hz}
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          cs_80Hz: e.target.value,
                        })
                      }
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">dB</InputAdornment>
                        ),
                      }}
                      aria-describedby="cs_80Hz"
                      inputProps={{
                        "aria-label": "cs_80Hz",
                      }}
                    />
                  </FormControl> */}
                  <FormControl>
                    <TextField
                      type="number"
                      label="100Hz"
                      name="cs_100Hz"
                      id="cs_100Hz"
                      value={formData.cs_100Hz}
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          cs_100Hz: e.target.value,
                        })
                      }
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">dB</InputAdornment>
                        ),
                      }}
                      aria-describedby="cs_100Hz"
                      inputProps={{
                        "aria-label": "cs_100Hz",
                      }}
                    />
                  </FormControl>
                  <FormControl>
                    <TextField
                      type="number"
                      label="125Hz"
                      name="cs_125Hz"
                      id="cs_125Hz"
                      value={formData.cs_125Hz}
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          cs_125Hz: e.target.value,
                        })
                      }
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">dB</InputAdornment>
                        ),
                      }}
                      aria-describedby="cs_125Hz"
                      inputProps={{
                        "aria-label": "cs_125Hz",
                      }}
                    />
                  </FormControl>
                  <FormControl>
                    <TextField
                      type="number"
                      label="160Hz"
                      name="cs_160Hz"
                      id="cs_160Hz"
                      value={formData.cs_160Hz}
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          cs_160Hz: e.target.value,
                        })
                      }
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">dB</InputAdornment>
                        ),
                      }}
                      aria-describedby="cs_160Hz"
                      inputProps={{
                        "aria-label": "cs_160Hz",
                      }}
                    />
                  </FormControl>
                  <FormControl>
                    <TextField
                      type="number"
                      label="200Hz"
                      name="cs_200Hz"
                      id="cs_200Hz"
                      value={formData.cs_200Hz}
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          cs_200Hz: e.target.value,
                        })
                      }
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">dB</InputAdornment>
                        ),
                      }}
                      aria-describedby="cs_200Hz"
                      inputProps={{
                        "aria-label": "cs_200Hz",
                      }}
                    />
                  </FormControl>
                  <FormControl>
                    <TextField
                      type="number"
                      label="250Hz"
                      name="cs_250Hz"
                      id="cs_250Hz"
                      value={formData.cs_250Hz}
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          cs_250Hz: e.target.value,
                        })
                      }
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">dB</InputAdornment>
                        ),
                      }}
                      aria-describedby="cs_250Hz"
                      inputProps={{
                        "aria-label": "cs_250Hz",
                      }}
                    />
                  </FormControl>
                  <FormControl>
                    <TextField
                      type="number"
                      label="315Hz"
                      name="cs_315Hz"
                      id="cs_315Hz"
                      value={formData.cs_315Hz}
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          cs_315Hz: e.target.value,
                        })
                      }
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">dB</InputAdornment>
                        ),
                      }}
                      aria-describedby="cs_315Hz"
                      inputProps={{
                        "aria-label": "cs_315Hz",
                      }}
                    />
                  </FormControl>
                  {/* <FormControl>
                    <TextField
                      type="number"
                      label="400Hz"
                      name="cs_400Hz"
                      id="cs_400Hz"
                      value={formData.cs_400Hz}
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          cs_400Hz: e.target.value,
                        })
                      }
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">dB</InputAdornment>
                        ),
                      }}
                      aria-describedby="cs_400Hz"
                      inputProps={{
                        "aria-label": "cs_400Hz",
                      }}
                    />
                  </FormControl>
                  <FormControl>
                    <TextField
                      type="number"
                      label="500Hz"
                      name="cs_500Hz"
                      id="cs_500Hz"
                      value={formData.cs_500Hz}
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          cs_500Hz: e.target.value,
                        })
                      }
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">dB</InputAdornment>
                        ),
                      }}
                      aria-describedby="cs_500Hz"
                      inputProps={{
                        "aria-label": "cs_500Hz",
                      }}
                    />
                  </FormControl> */}
                </Stack>
              </Grid>
              <Grid item xs={12} md={6}>
                <Stack spacing={2}>
                  <FormControl>
                    <TextField
                      type="number"
                      label="630Hz"
                      name="cs_630Hz"
                      id="cs_630Hz"
                      value={formData.cs_630Hz}
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          cs_630Hz: e.target.value,
                        })
                      }
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">dB</InputAdornment>
                        ),
                      }}
                      aria-describedby="cs_630Hz"
                      inputProps={{
                        "aria-label": "cs_630Hz",
                      }}
                    />
                  </FormControl>
                  <FormControl>
                    <TextField
                      type="number"
                      label="800Hz"
                      name="cs_800Hz"
                      id="cs_800Hz"
                      value={formData.cs_800Hz}
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          cs_800Hz: e.target.value,
                        })
                      }
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">dB</InputAdornment>
                        ),
                      }}
                      aria-describedby="cs_800Hz"
                      inputProps={{
                        "aria-label": "cs_800Hz",
                      }}
                    />
                  </FormControl>
                  <FormControl>
                    <TextField
                      type="number"
                      label="1000Hz"
                      name="cs_1000Hz"
                      id="cs_1000Hz"
                      value={formData.cs_1000Hz}
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          cs_1000Hz: e.target.value,
                        })
                      }
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">dB</InputAdornment>
                        ),
                      }}
                      aria-describedby="cs_1000Hz"
                      inputProps={{
                        "aria-label": "cs_1000Hz",
                      }}
                    />
                  </FormControl>
                  <FormControl>
                    <TextField
                      type="number"
                      label="1250Hz"
                      name="cs_1250Hz"
                      id="cs_1250Hz"
                      value={formData.cs_1250Hz}
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          cs_1250Hz: e.target.value,
                        })
                      }
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">dB</InputAdornment>
                        ),
                      }}
                      aria-describedby="cs_1250Hz"
                      inputProps={{
                        "aria-label": "cs_1250Hz",
                      }}
                    />
                  </FormControl>
                  <FormControl>
                    <TextField
                      type="number"
                      label="1600Hz"
                      name="cs_1600Hz"
                      id="cs_1600Hz"
                      value={formData.cs_1600Hz}
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          cs_1600Hz: e.target.value,
                        })
                      }
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">dB</InputAdornment>
                        ),
                      }}
                      aria-describedby="cs_1600Hz"
                      inputProps={{
                        "aria-label": "cs_1600Hz",
                      }}
                    />
                  </FormControl>
                  <FormControl>
                    <TextField
                      type="number"
                      label="2000Hz"
                      name="cs_2000Hz"
                      id="cs_2000Hz"
                      value={formData.cs_2000Hz}
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          cs_2000Hz: e.target.value,
                        })
                      }
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">dB</InputAdornment>
                        ),
                      }}
                      aria-describedby="cs_2000Hz"
                      inputProps={{
                        "aria-label": "cs_2000Hz",
                      }}
                    />
                  </FormControl>
                  <FormControl>
                    <TextField
                      type="number"
                      label="2500Hz"
                      name="cs_2500Hz"
                      id="cs_2500Hz"
                      value={formData.cs_2500Hz}
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          cs_2500Hz: e.target.value,
                        })
                      }
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">dB</InputAdornment>
                        ),
                      }}
                      aria-describedby="cs_2500Hz"
                      inputProps={{
                        "aria-label": "cs_2500Hz",
                      }}
                    />
                  </FormControl>
                  <FormControl>
                    <TextField
                      type="number"
                      label="3150Hz"
                      name="cs_3150Hz"
                      id="cs_3150Hz"
                      value={formData.cs_3150Hz}
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          cs_3150Hz: e.target.value,
                        })
                      }
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">dB</InputAdornment>
                        ),
                      }}
                      aria-describedby="cs_3150Hz"
                      inputProps={{
                        "aria-label": "cs_3150Hz",
                      }}
                    />
                  </FormControl>
                  {/* <FormControl>
                    <TextField
                      type="number"
                      label="4000Hz"
                      name="cs_4000Hz"
                      id="cs_4000Hz"
                      value={formData.cs_4000Hz}
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          cs_4000Hz: e.target.value,
                        })
                      }
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">dB</InputAdornment>
                        ),
                      }}
                      aria-describedby="cs_4000Hz"
                      inputProps={{
                        "aria-label": "cs_4000Hz",
                      }}
                    />
                  </FormControl>
                  <FormControl>
                    <TextField
                      type="number"
                      label="5000Hz"
                      name="cs_5000Hz"
                      id="cs_5000Hz"
                      value={formData.cs_5000Hz}
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          cs_5000Hz: e.target.value,
                        })
                      }
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">dB</InputAdornment>
                        ),
                      }}
                      aria-describedby="cs_5000Hz"
                      inputProps={{
                        "aria-label": "cs_5000Hz",
                      }}
                    />
                  </FormControl> */}
                </Stack>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
        <Grid align="right">
          <Button
            variant="contained"
            size="large"
            type="submit"
            // onClick={() => changeCreds()}
            // value={id ? "Update" : "Save"}
          >
            Save changes
          </Button>
          {/* <Button
          variant="contained"
          title="Fetch data"
          type="submit"
          onClick={() => fetchUserCreds()}
        >
          Hein ?
        </Button> */}
        </Grid>
      </form>
    </>
  );
}
